import { render, staticRenderFns } from "./TipoCreateUpdate.vue?vue&type=template&id=775542fa&"
import script from "./TipoCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TipoCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports